import React, { useEffect } from 'react';
import qs from 'qs';
import AppExpiredView from './AppExpiredView';
import useFmcHost from 'hooks/useFmcHost';
import { applicationTimeout } from 'fmc-sdk';
import useWorkflow from 'hooks/useWorkflow';
import { useSecureQueryParameters } from 'hooks/useQueryParameters';
import env from 'utils/env';

const AppExpired: React.FC = props => {
  const fmcDispatch = useFmcHost();
  const allowedQueryParameters = useSecureQueryParameters();
  const { timeoutRestartPath } = useWorkflow();

  const restartLinkPath = `${env.BASENAME}${timeoutRestartPath}/${qs.stringify(
    allowedQueryParameters,
    {
      addQueryPrefix: true,
    },
  )}`.replace(/\/\//g, '/');

  useEffect(() => {
    fmcDispatch(applicationTimeout());
  }, [fmcDispatch]);
  return <AppExpiredView {...props} restartPath={restartLinkPath} />;
};

export default AppExpired;
